import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable } from 'rxjs';

@UntilDestroy()
@Directive({
  selector: '[appFocusManager]'
})
export class FocusManagerDirective implements AfterViewInit {
  @Input('appFocusManagerAdtSrc') additionalFocusSourse: BehaviorSubject<boolean>;
  focused$ = new BehaviorSubject<boolean>(false);
  private focusChanged$ = new BehaviorSubject<boolean>(false);

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
  ) {
    this.focusChanged$.subscribe({
      next: (focusIn) => {
        if (!focusIn) {
          setTimeout(() => {
            if (this.focusChanged$.getValue() === false) {
              if (this.additionalFocusSourse) {
                if (this.additionalFocusSourse.getValue()) {
                  return;
                }
              }
              console.log('Now Focus is lost');
              this.focused$.next(false);
            }
          }, 100);
        }

      }
    })
  }

  ngAfterViewInit() {
    console.log(this.elRef.nativeElement);
    this.renderer.listen(this.elRef.nativeElement, 'focusin', (e) => {
      console.log('IN', e.relatedTarget, e);
      this.focusChanged$.next(true);
      this.focused$.next(true);
    });
    this.renderer.listen(this.elRef.nativeElement, 'focusout', (e) => {
      console.log('OUT', e.relatedTarget, e);
      this.focusChanged$.next(false);
    });

    if (this.additionalFocusSourse) {
      this.additionalFocusSourse.pipe(untilDestroyed(this)).subscribe({
        next: (focused) => {
          if (!focused) {
            setTimeout(() => {
              if (this.focusChanged$.getValue() === false) {
                console.log('Now Focus is lost (2)');
                this.focused$.next(false);
              }
            },100);
          }

        }
      })
    }
  }
}
